
import airplane from '../../../../assets/Icons/airplane_installed.svg';

import { Popover } from "@mui/material";
import "./ParentTree.css";
import { useEffect, useRef, useState } from "react";
import { CONTEXT_TYPES } from '../../../../globals/globals';
import axios from 'axios';
import { getPartHierarchy } from '../../Services/PartsService';
import { attachContextmenuInfo } from '../../../../services/contextMenuService';

export const ParentTree = ({ data, children, item }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [treeNodes, setTreeNodes] = useState([]);
	const nodeRefs = useRef([]);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	useEffect(()=>{
		if (anchorEl){
				setTreeNodes(data.partPositionList);
		}    
	},[anchorEl]);

	const open = Boolean(anchorEl);
	const id_popover = open ? 'simple-popover' : undefined;

	return (<div className='shared wrapper'>
		<span aria-describedby={id_popover} className="shared part-number" onClick={handleClick}>
			{children} 33343
		</span>
		<Popover
			id={id_popover}
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			slotProps={{
				paper: {
					style: {
						borderRadius: '12px',
						boxShadow: 'var(--pop-over-shadow)'
					}
				}
			}}

		>
			<div className="shared window">
				<div className="shared header">
					<i className="shared airplane icon-airplane-installed">
						{/* <img src={airplane}/> */}
					</i>
					<div className="shared header-info">
						<div className="shared title">Installed on - {item.aircraft_name}</div>
						<div className="shared subtitle">
							<span className="shared position-label">NLA Position</span>
							<span className="shared position">{data.nlaPoistion}</span>
						</div>
					</div>
				</div>
				<div className="shared content">
					{/* treeNodes deben estar ordenados */}
					{treeNodes.map((node, key) =>
						<div className={`shared node ${key === treeNodes.length - 1 ? 'last-node':''}`} key={key} style={{ paddingLeft: `${(key * 16) + 16}px` }}>
							<div className="shared node-branch">
								<span className={`shared node-dot ${key === treeNodes.length - 1 ? 'last-node-dot':''}`} ref={(el) => (nodeRefs.current[key] = el)}></span>
								{key < treeNodes.length - 1 && <span className="shared node-connector"></span>}
							</div>

							<div className="shared node-content">
								<span><b className={`shared ${key === treeNodes.length - 1 ? 'last-part':''}`}>{node.partName}</b></span>
								<p> (<b className='smallB'>PN:</b> {node.partNumber} {Boolean(node.serialNumber) && <> <b className='smallB'>SN</b>: {node.serialNumber}</>}) {key === 0 && <span className="first-info">(Highest Assembly)</span>}</p>
								
							</div>
						</div>)}
				</div>
			</div>
		</Popover>



	</div>)
}